import React, { useEffect, useContext } from 'react';
import { AUTOMATICSTATETRANSITIONS_QUERY } from '../../queries';
import { ServiceContext } from 'providers/ServiceProvider';
import { Card } from '@totalsoft/rocket-ui';
import ExportAction from './actions/ExportAction';
import { useApolloClient } from '@apollo/client';
import { getListBrowserStore, useListBrowserUtils } from '@ts-private/list-browser';
import ListAltIcon from '@mui/icons-material/ListAlt';
import { useMemo } from 'react';
import TableListBrowser from 'features/common/components/table-list-browser/TableListBrowser';
import ApolloFetchingComponent from 'features/common/components/apollo-fetching/ApolloFetchingComponent';
import AutomaticStateTransitionItem from './AutomaticStateTransitionItem';

export const automaticStateTransitionsStore = getListBrowserStore({
  filterDefinitions: [
    {
      name: 'documentCode',
      caption: 'AutomaticStateTransitions.DocumentTypeCode',
      type: 'text'
    },
    {
      name: 'documentName',
      caption: 'AutomaticStateTransitions.DocumentTypeName',
      type: 'text'
    },
    {
      name: 'fromStateCode',
      caption: 'AutomaticStateTransitions.InitialStateCode',
      type: 'text'
    },
    {
      name: 'fromStateName',
      caption: 'AutomaticStateTransitions.InitialStateName',
      type: 'text'
    },
    {
      name: 'inactive',
      caption: 'AutomaticStateTransitions.Inactive',
      type: 'boolean'
    }
  ],
  orderByFields: [
    {
      caption: 'AutomaticStateTransitions.DocumentTypeName',
      value: 'DocumentName'
    },
    {
      caption: 'AutomaticStateTransitions.DocumentTypeCode',
      value: 'DocumentCode'
    }
  ],
  pager: {
    orderBy: 'DocumentName',
    direction: 'asc'
  }
});

const AutomaticStateTransitionListBrowser = () => {
  const client = useApolloClient();
  const [activeService] = useContext(ServiceContext);
  const { addActions } = useListBrowserUtils(automaticStateTransitionsStore);

  const fetchingOptions = useMemo(
    () => ({
      queryOptions: {
        query: AUTOMATICSTATETRANSITIONS_QUERY,
        name: 'automaticStateTransitions'
      }
    }),
    []
  );

  useEffect(() => {
    if (activeService) {
      client.cache.evict({ id: 'ROOT_QUERY', fieldName: 'automaticStateTransitions' });
      client.cache.gc();
    }
  }, [activeService, client]);

  useEffect(() => {
    addActions([
      {
        name: 'export',
        icon: <ExportAction />
      }
    ]);
  }, [addActions]);

  const columns = useMemo(
    () => [
      { name: 'documentTypeCode', caption: 'AutomaticStateTransitions.DocumentTypeCode' },
      { name: 'documentTypeName', caption: 'AutomaticStateTransitions.DocumentTypeName' },
      { name: 'initialStateCode', caption: 'AutomaticStateTransitions.InitialStateCode' },
      { name: 'initialStateName', caption: 'AutomaticStateTransitions.InitialStateName' },
      { name: 'inactive', caption: 'AutomaticStateTransitions.Inactive', width: '100px', align: 'center' },
      { name: 'actions', caption: 'Actions', width: '120px' }
    ],
    []
  );

  return (
    <Card icon={ListAltIcon}>
      <TableListBrowser
        name='automatic-state-transitions-browser'
        store={automaticStateTransitionsStore}
        ItemComponent={AutomaticStateTransitionItem}
        columns={columns}
      />
      <ApolloFetchingComponent store={automaticStateTransitionsStore} options={fetchingOptions} />
    </Card>
  );
};

export default AutomaticStateTransitionListBrowser;
